module.exports = "/assets/933c6153bfe227dc13efdeee8f7d6dac.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WB.png
// module id = 1954
// module chunks = 0